import { useState, useRef, useEffect } from 'react';
import matrixImageSrc from './matrix.png';

const MatrixOfDestiny = ({ day, month, year }) => {
  const canvasRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [matrixImage, setMatrixImage] = useState(null);

  const [num_1, setNum_1] = useState(0);
  const [num_2, setNum_2] = useState(0);
  const [num_3, setNum_3] = useState(0);
  const [num_4, setNum_4] = useState(0);
  const [num_5, setNum_5] = useState(0);
  const [num_6, setNum_6] = useState(0);
  const [num_7, setNum_7] = useState(0);
  const [num_8, setNum_8] = useState(0);
  const [num_9, setNum_9] = useState(0);
  const [num_10, setNum_10] = useState(0);
  const [num_11, setNum_11] = useState(0);
  const [num_12, setNum_12] = useState(0);
  const [num_13, setNum_13] = useState(0);
  const [num_14, setNum_14] = useState(0);
  const [num_15, setNum_15] = useState(0);
  const [num_16, setNum_16] = useState(0);
  const [num_17, setNum_17] = useState(0);
  const [num_18, setNum_18] = useState(0);
  const [num_19, setNum_19] = useState(0);
  const [num_20, setNum_20] = useState(0);
  const [num_21, setNum_21] = useState(0);
  const [num_22, setNum_22] = useState(0);

  const check = (num) => {
    if (num > 22) { 
      let num_string = '';
      num_string = '' + num;
      
      let nums = 0;
      
      for(let i = 0; i < num_string.length; i++) {
          nums += parseInt(num_string[i]);
      }
      return nums
    }
    else {
        return num
    }
  }

  const sumDigits = (num) =>
    num.toString().split('').reduce((sum, digit) => sum + Number(digit), 0);

  useEffect(() => {
    let tempNum1 = parseInt(day);
    tempNum1 = check(tempNum1);
    setNum_1(tempNum1);

    let tempNum2 = parseInt(month);
    setNum_2(tempNum2);
    
    let tempNum3 = 0;
    tempNum3 = sumDigits(year);
    setNum_3(tempNum3);
    
    let tempNum4 = tempNum1 + tempNum2 + tempNum3;
    tempNum4 = check(tempNum4);
    setNum_4(tempNum4);
    
    let tempNum5 = tempNum1 + tempNum2 + tempNum3 + tempNum4;
    tempNum5 = check(tempNum5);
    setNum_5(tempNum5);
    
    let tempNum6 = tempNum1 + tempNum2;
    tempNum6 = check(tempNum6);
    setNum_6(tempNum6);
    
    let tempNum7 = tempNum2 + tempNum3;
    tempNum7 = check(tempNum7);
    setNum_7(tempNum7);
    
    let tempNum8 = tempNum3 + tempNum4;
    tempNum8 = check(tempNum8);
    setNum_8(tempNum8);
    
    let tempNum9 = tempNum1 + tempNum4;
    tempNum9 = check(tempNum9);
    setNum_9(tempNum9);
    
    let tempNum10 = tempNum5 + tempNum4;
    tempNum10 = check(tempNum10);
    setNum_10(tempNum10);
    
    let tempNum11 = tempNum5 + tempNum3;
    tempNum11 = check(tempNum11);
    setNum_11(tempNum11);
    
    let tempNum12 = tempNum10 + tempNum11;
    tempNum12 = check(tempNum12);
    setNum_12(tempNum12);
    
    let tempNum14 = tempNum10 + tempNum12;
    tempNum14 = check(tempNum14);
    setNum_14(tempNum14);
    
    let tempNum13 = tempNum12 + tempNum11;
    tempNum13 = check(tempNum13);
    setNum_13(tempNum13);
    
    let tempNum15 = tempNum10 + tempNum4;
    tempNum15 = check(tempNum15);
    setNum_15(tempNum15);
    
    let tempNum16 = tempNum5 + tempNum2;
    tempNum16 = check(tempNum16);
    setNum_16(tempNum16);
    
    let tempNum17 = tempNum16 + tempNum2;
    tempNum17 = check(tempNum17);
    setNum_17(tempNum17);
    
    let tempNum18 = tempNum5 + tempNum16;
    tempNum18 = check(tempNum18);
    setNum_18(tempNum18);
    
    let tempNum19 = tempNum5 + tempNum1;
    tempNum19 = check(tempNum19);
    setNum_19(tempNum19);
    
    let tempNum20 = tempNum19 + tempNum1;
    tempNum20 = check(tempNum20);
    setNum_20(tempNum20);
    
    let tempNum21 = tempNum5 + tempNum19;
    tempNum21 = check(tempNum21);
    setNum_21(tempNum21);
    
    let tempNum22 = tempNum11 + tempNum3;
    tempNum22 = check(tempNum22);
    setNum_22(tempNum22);
    
  }, [day, month, year]);

  const loadImage = () => {
    const img = new Image();
    img.src = matrixImageSrc;
    img.onload = () => {
      setMatrixImage(img);
      setImageLoaded(true);
    };
  };

  const drawCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    if (imageLoaded && matrixImage) {
      ctx.drawImage(matrixImage, 0, 0, canvas.width, canvas.height);

      ctx.font = '20px Arial';
      ctx.fillStyle = 'black';

      ctx.fillText(`${num_11}`, 472, 305);
      ctx.fillText(`${num_12}`, 380, 394);
      ctx.fillText(`${num_13}`, 442, 373);

    }
  };

  useEffect(() => {
    loadImage();
  }, []); 

  useEffect(() => {
    if (imageLoaded) {
      drawCanvas();
    }
  }, [imageLoaded, num_1, num_2, num_3, num_4]);

  return (
    <div>
      <canvas ref={canvasRef} width="600" height="600" />
    </div>
  );
};

export default MatrixOfDestiny;
